/**
 * Utilitários para formatação de nomes
 */

/**
 * Extrai o primeiro e último nome de um nome completo
 * @param fullName Nome completo do usuário
 * @returns String formatada com primeiro e último nome
 */
export const getDisplayName = (fullName?: string): string => {
  if (!fullName || fullName.trim() === '') {
    return 'Usuário';
  }

  const nameParts = fullName.trim().split(' ').filter(part => part.length > 0);
  
  if (nameParts.length === 1) {
    // Se tem apenas um nome, retorna ele
    return nameParts[0];
  } else if (nameParts.length === 2) {
    // Se tem dois nomes, retorna ambos
    return `${nameParts[0]} ${nameParts[1]}`;
  } else {
    // Se tem mais de dois nomes, retorna o primeiro e o último
    return `${nameParts[0]} ${nameParts[nameParts.length - 1]}`;
  }
};
